(() => {
  'use strict';

  if (customElements.get('oem-upgrade')) return;

  customElements.define('oem-upgrade', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      const form = this.querySelector('form');
      const email = form.querySelector('[name="email"]');
      const button = form.querySelector('button');
      const message = this.querySelector('.upgrade__message');
      const followup = this.querySelector('.upgrade__followup');
      const label = button.textContent;
      const retryMessage = 'We couldn’t request your link. Please try again in a few minutes. If this continues, contact us for help.';
      button.disabled = false;

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (this.pending || this.submitted) return;
        email.value = email.value.trim();
        if (!form.reportValidity()) return;

        this.pending = true;
        button.disabled = true;
        email.readOnly = true;
        button.textContent = 'Requesting your link…';
        form.setAttribute('aria-busy', 'true');
        message.textContent = '';
        delete message.dataset.state;
        followup.hidden = true;

        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 20000);

        try {
          const response = await fetch('https://vin.jlractive.com/api/upgrade-link', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'omit',
            cache: 'no-store',
            body: JSON.stringify({ email: email.value }),
            signal: controller.signal,
          });
          const result = await response.json();

          if (!response.ok) {
            message.dataset.state = 'error';
            message.textContent = typeof result?.error === 'string' && result.error.trim()
              ? result.error : retryMessage;
            return;
          }

          if (result?.success !== true || typeof result.message !== 'string' || !result.message.trim()) {
            throw new Error('Unexpected response');
          }

          this.submitted = true;
          message.dataset.state = 'success';
          message.textContent = result.message;
          followup.hidden = false;
        } catch {
          message.dataset.state = 'error';
          message.textContent = retryMessage;
        } finally {
          clearTimeout(timeout);
          this.pending = false;
          button.disabled = Boolean(this.submitted);
          email.readOnly = Boolean(this.submitted);
          button.textContent = this.submitted ? 'Request received' : label;
          button.classList.toggle('is-submitted', Boolean(this.submitted));
          form.removeAttribute('aria-busy');
        }
      });
    }
  });
})();
